import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import Icon from '../../../components/AppIcon';

const CommunicationAnalytics = ({ data }) => {
  const campaigns = data?.campaigns || [];
  const logs = data?.logs || [];

  // Group logs by type
  const typeMap = {};
  logs?.forEach(log => {
    const type = log?.communication_type || 'unknown';
    typeMap[type] = (typeMap?.[type] || 0) + 1;
  });

  const chartData = Object.entries(typeMap)?.map(([type, count]) => ({
    name: type?.replace(/_/g, ' ')?.replace(/\b\w/g, c => c?.toUpperCase()),
    count
  }));

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="bg-card border border-border rounded-lg p-4">
          <p className="text-sm text-muted-foreground">Total Campaigns</p>
          <p className="text-2xl font-bold text-foreground">{campaigns?.length}</p>
        </div>
        <div className="bg-card border border-border rounded-lg p-4">
          <p className="text-sm text-muted-foreground">Active Campaigns</p>
          <p className="text-2xl font-bold text-foreground">{campaigns?.filter(c => c?.status === 'active')?.length}</p>
        </div>
        <div className="bg-card border border-border rounded-lg p-4">
          <p className="text-sm text-muted-foreground">Total Interactions</p>
          <p className="text-2xl font-bold text-foreground">{logs?.length}</p>
        </div>
      </div>

      {chartData?.length > 0 ? (
        <div className="bg-card border border-border rounded-lg p-6">
          <h3 className="text-lg font-semibold text-foreground mb-4">Communication Breakdown</h3>
          <ResponsiveContainer width="100%" height={280}>
            <BarChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" fontSize={12} />
              <YAxis fontSize={12} />
              <Tooltip />
              <Bar dataKey="count" fill="#3b82f6" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <div className="bg-card border border-border rounded-lg p-12 text-center">
          <Icon name="MessageSquare" size={48} className="text-muted-foreground mx-auto mb-4 opacity-40" />
          <p className="text-muted-foreground">No communication data available yet</p>
        </div>
      )}
    </div>
  );
};

export default CommunicationAnalytics;